import { ArticleType } from '@wix/answers-api';
import { Box } from '@wix/design-system';
import React, { FC, useMemo } from 'react';

import { HelpCenterArticle } from '../../types';
import { FeatureRequestStatus } from './FeatureRequestStatus';
import { KnownIssueStatus } from './KnownIssueStatus';

export interface ArticleFooterProps {
  article: HelpCenterArticle;
}

export const ArticleHeader: FC<ArticleFooterProps> = ({ article }) => {
  const component = useMemo(() => {
    if (article.type === ArticleType.KNOWN_ISSUE) {
      return <KnownIssueStatus article={article} />;
    } else if (article.type === ArticleType.FEATURE_REQUEST) {
      return <FeatureRequestStatus article={article} />;
    }
    return null;
  }, [article]);

  return component ? (
    <Box direction="vertical" marginTop="SP3" marginBottom="SP1">
      {component}
    </Box>
  ) : null;
};
